import React, {Component, Fragment} from 'react'
import PropTypes from "prop-types";

import './../assets/css/global.scss';
import './../assets/css/index.scss';

import Tester from "../components/tester/Tester";
import {withRouter} from "react-router-dom";
import { isAuth, isInHub } from "../helpers/AppHelper";
import GeneralTrack from "../services/track/GeneralTrack";
import CookieScripts from "../components/cookieScripts/CookieScripts";

class DefaultLayout extends Component {
    hubPageViewTracked = false;

    componentDidMount() {
        this.trackDataLayerSession();
        GeneralTrack.getInstance().processSessionStorageEvents();

        this.props.history.listen((location, action) => {
            this.trackDataLayerSession();
            GeneralTrack.getInstance().processSessionStorageEvents();
        });
    };

    trackDataLayerSession = () => {
        if(isInHub() && isAuth()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'userSessionLoaded': 'true'});
            window.dataLayer.push({"event": "UserSessionAndCookiePreferencesLoaded"});
        }
    };

    render() {
        return (
            <Fragment>
                {
                    this.props.hasHeader ?
                        <Tester companyName="WeVideo" pageName={this.props.pageName} />
                        : null
                }
                {this.props.children}
                <CookieScripts />
            </Fragment>
        );
    }
}

DefaultLayout.defaultProps = {
    pageName: '',
    hasHeader: true,
};

DefaultLayout.propTypes = {
    pageName: PropTypes.string,
    hasHeader: PropTypes.bool,
};

export default withRouter(DefaultLayout);
